import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { qualityMaturityApi } from './apis';
import { rootRouteRef } from './routes';

// The page renders its own core-components Page/Header ("Quality Maturity" plus
// the fleet-radar subtitle), so the framework header is off to avoid a second
// one. Moving to the framework/BUI header belongs to the MUI→BUI track.
const qualityMaturityPage = PageBlueprint.make({
  params: {
    path: '/quality-maturity',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/QualityMaturityPage').then(m => (
        <m.QualityMaturityPage />
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'quality-maturity',
  title: 'Quality Maturity',
  icon: <TrackChangesIcon fontSize="inherit" />,
  info: { packageJson: () => import('../package.json') },
  routes: { root: rootRouteRef },
  extensions: [qualityMaturityApi, qualityMaturityPage],
});
